///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import * as types from "./types";

const getLesserProgressedMode = (modeA, modeB) =>
  modeA.status < modeB.status ? modeA : modeB;

const getLeastProgressedModeWithoutRole = modes => {
  let leastProgressedMode;

  for (let mode of modes) {
    leastProgressedMode =
      leastProgressedMode === undefined
        ? mode
        : getLesserProgressedMode(leastProgressedMode, mode);
  }

  return leastProgressedMode;
};

export const getLeastProgressedMode = (modes, user) => {
  let matchingMode;

  if (user.seeAllActiveBids) {
    return getLeastProgressedModeWithoutRole(modes);
  } else {
    if (
      user.role === types.userRole.tlPricingAnalyst ||
      user.role === types.userRole.assetBasedPricingUser ||
      user.role === types.userRole.carrierRelationsRepresentative ||
      user.role === types.userRole.procurementRepresentative ||
      user.userRoleForManagementUser === types.userRole.tlPricingAnalyst ||
      user.userRoleForManagementUser === types.userRole.assetBasedPricingUser ||
      user.userRoleForManagementUser ===
        types.userRole.carrierRelationsRepresentative ||
      user.userRoleForManagementUser ===
        types.userRole.procurementRepresentative
    ) {
      matchingMode = modes.find(
        mode =>
          mode.mode === types.mode.tl && mode.status !== types.status.closed
      );
    } else if (
      user.role === types.userRole.ltlPricingAnalyst ||
      user.userRoleForManagementUser === types.userRole.ltlPricingAnalyst
    ) {
      matchingMode = modes.find(
        mode =>
          mode.mode === types.mode.ltl && mode.status !== types.status.closed
      );
    } else if (
      user.role === types.userRole.imdlPricingAnalyst ||
      user.userRoleForManagementUser === types.userRole.imdlPricingAnalyst
    ) {
      matchingMode = modes.find(
        mode =>
          mode.mode === types.mode.imdl && mode.status !== types.status.closed
      );
    }

    return matchingMode
      ? matchingMode
      : getLeastProgressedModeWithoutRole(modes);
  }
};

export default getLeastProgressedMode;
